import { PitchPlayerHoursResponse } from '@intelligent-play-v2/domain';
import { FilteredStatisticsParams } from '~/types';
import { queryBuilder } from '~/api';

export const getPlayerHours = async ({
  pitchIds,
  timePeriod,
  from,
  to,
  timezone,
  dailyStartTime,
  dailyEndTime,
  includedDays,
}: FilteredStatisticsParams): Promise<PitchPlayerHoursResponse[]> => {
  const { data } = await queryBuilder('GET', 'stats/playerHours', {
    timePeriod,
    from,
    to,
    pitchIds: pitchIds.join(','),
    timezone,
    dailyStartTime,
    dailyEndTime,
    includedDays: includedDays?.join(','),
  });
  return data;
};
